module.exports = require("connected-react-router");